import { all, call, fork, put, takeLatest } from "redux-saga/effects";

// import { getDateWithFormat } from '../../helpers/Utils';
import { API } from "aws-amplify";
import * as log from "loglevel";
import { GROUP_NAMES_GET, HOTEL_SETTINGS_GET } from "../actions";
import { getHotelSettingsSuccess, getHotelSettingsError, getGroupNamesSuccess, getGroupNamesError } from "./actions";
import getHotelConfig from "../../getHotelConfig";

export const getHotelSettingsAsync = async () => {
  try {
    const result = await getHotelConfig("SAGA");
    return result;
  } catch (err) {
    log.error("HotelConfig Err", err);
    throw err;
  }
};

export const getHotelGroupNamesAsync = async (payload, api = API, hotel_id) => {
  try {
    const path = `/users/getUserGroupNames`;
    const hotelSettings = await getHotelConfig("SAGA");
    const { hotelId } = hotelSettings;
    const myInit = {
      queryStringParameters: {
        hotel_id: hotelId
      },
      body: { ...payload }
    };
    const result = await api.get("WebeeAPI", path, myInit);
    return result;
  } catch (err) {
    log.error(err);
  }
};

export function* getHotelSettingsSaga() {
  try {
    /* TODO Check TTL before fetching, store expirationDate 
    on store on success (Calculation = client's current time + TTL inside of the config file)
    */
    const response = yield call(getHotelSettingsAsync);
    if (response) {
      yield put(getHotelSettingsSuccess(response));
    } else {
      throw new Error("Hotel settings not provided");
    }
  } catch (error) {
    if (error && error.message) {
      yield put(getHotelSettingsError(`Hotel config error: ${JSON.stringify(error.message)}`));
    } else {
      yield put(getHotelSettingsError("Hotel config error"));
    }
  }
}

export function* getHotelGroupNamesSaga() {
  try {
    /* TODO Check TTL before fetching, store expirationDate 
    on store on success (Calculation = client's current time + TTL inside of the config file)
    */
    const response = yield call(getHotelGroupNamesAsync);
    if (response) {
      yield put(getGroupNamesSuccess(response));
    } else {
      throw new Error("Hotel settings not provided");
    }
  } catch (error) {
    if (error && error.message) {
      yield put(getGroupNamesError(`Hotel config error: ${JSON.stringify(error.message)}`));
    } else {
      yield put(getGroupNamesError("Hotel config error"));
    }
  }
}

export function* watchGetHotelSettings() {
  yield takeLatest(HOTEL_SETTINGS_GET, getHotelSettingsSaga);
}

export function* watchGetHotelGroupNames() {
  yield takeLatest(GROUP_NAMES_GET, getHotelGroupNamesSaga);
}

export default function* rootSaga() {
  yield all([fork(watchGetHotelSettings), fork(watchGetHotelGroupNames)]);
}
